import React, { useCallback, useId, useRef, useState } from 'react';
const RangeSlider = ({
  ref = null,
  minValue = '0',
  maxValue = '100',
  defaultValue = '0',
  stepValue = '1',
  disabled = false,
  onChange = () => {}
}) => {
  const componentId = useId();
  const componentRef = useRef(ref);
  const [value, setValue] = useState(defaultValue);
  const handleOnChange = useCallback(event => {
    const inputObject = event.target;
    setValue(inputObject.value);
    onChange(inputObject);
  }, [onChange]);
  const calculateBackground = useCallback(() => `linear-gradient(to right, #007BC0 0%, #007BC0 ${value}%, #C6C8CB ${value}%, #C6C8CB 100%)`, [value]);
  return /*#__PURE__*/React.createElement("div", {
    id: `ebds-rangeslider-${componentId}`,
    ref: componentRef,
    className: "ebds-rangeslider",
    "data-testid": "ebds-rangeslider"
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: minValue,
    max: maxValue,
    className: "ebds-rangeslider-input",
    value: value,
    step: stepValue,
    disabled: disabled,
    onChange: event => handleOnChange(event),
    style: {
      background: calculateBackground()
    }
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, value)));
};
export default RangeSlider;